import { RuleForm } from "./_RuleForm";

export function RuleCreate() {
  return <RuleForm action="create" />;
}

export default RuleCreate;
